import { render, staticRenderFns } from "./RoleInfo.vue?vue&type=template&id=2bbf0f7e&scoped=true&"
import script from "./RoleInfo.vue?vue&type=script&lang=js&"
export * from "./RoleInfo.vue?vue&type=script&lang=js&"
import style0 from "./RoleInfo.vue?vue&type=style&index=0&id=2bbf0f7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf0f7e",
  null
  
)

export default component.exports